import { FaGoogle } from "react-icons/fa6";

const EmailSetup = ({ handleConnect }) => {
  return (
    <div className="flex flex-col justify-center items-center gap-8 w-full">
      <h1 className="text-2xl font-semibold">Select Your Email Provider</h1>
      <div className="flex items-center justify-between w-full bg-blue-50/50 rounded-md p-3 border">
        <div className="flex items-center justify-center gap-3">
          <FaGoogle className="text-4xl text-red-500" />
          <p className="text-lg font-semibold text-gray-700">Google / Gmail</p>
        </div>
        <button
          className="border-2 border-indigo-500/50 hover:border-indigo-500 duration-300 rounded-md py-2 px-4"
          onClick={handleConnect}
        >
          Connect
        </button>
      </div>
    </div>
  );
};

export default EmailSetup;
